import { memo, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"

import {
  folders,
  setFolderFilter,
  setTypeFilter,
  type,
} from "rtk-slice"

import { isMobile } from "utils/mediaQuery"
import toggleCapitalization from "utils/toggleCapitalization"

import {
  Avatar,
  Box,
  CardHeader,
  Chip,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material"

import {
  FolderDuotone,
  HTMLLogo,
  NAIcon,
  SASSLogo,
  TypescriptIcon,
} from "ui-icons"

const Cardheader = ({ title, folder, snippetType }) => {
  const dispatch = useDispatch()
  const {
    palette: {
      primary: { main },
      text: { cancel },
    },
  } = useTheme()
  const foldersState = useSelector(folders)
  const typeState = useSelector(type)

  const folderIsExist = useMemo(
    () => foldersState.find((item) => item.title === folder?.title),
    [folder?.title, foldersState]
  )

  const shrotFolderTitle = useMemo(
    () =>
      folderIsExist &&
      (folder.title.length > 20
        ? `${folder.title.slice(0, 21)}...`
        : folder.title),
    [folder?.title, folderIsExist]
  )

  const handleSetTypeFilter = (type) =>
    dispatch(setTypeFilter(type || null))

  const handleSetFolderFilter = () =>
    dispatch(setFolderFilter(folder?.title || null))

  return (
    <CardHeader
      avatar={
        <Tooltip
          title={
            snippetType
              ? snippetType === "css"
                ? "SASS"
                : toggleCapitalization("upper", snippetType)
              : null
          }
        >
          <Avatar
            sx={{
              cursor: "pointer",
              width: 40,
              height: 40,
              flex: 1,
              bgcolor: snippetType
                ? snippetType === "html"
                  ? "#E44D26"
                  : snippetType === "typescript"
                  ? "#3178C6"
                  : "#A2155C"
                : "transparent",

              borderRadius: snippetType === null ? 0 : "50%",
            }}
            aria-label="snippetType"
            onClick={() => handleSetTypeFilter(snippetType)}
          >
            {snippetType ? (
              snippetType === "html" ? (
                <HTMLLogo width="32" height="32" />
              ) : snippetType === "typescript" ? (
                <TypescriptIcon width="24" height="24" />
              ) : (
                <SASSLogo />
              )
            ) : (
              <NAIcon
                width="32"
                height="32"
                color={typeState === null ? main : cancel}
              />
            )}
          </Avatar>
        </Tooltip>
      }
      title={
        <Tooltip title={title?.length > 20 ? title : ""}>
          <Box
            sx={{
              display: "flex",
              minWidth: 0,
              pb: "0.5em",
              px: "0.5em",
            }}
            className="Title"
          >
            <Typography
              className="Typo"
              aria-label="title"
              variant="body1"
              sx={{
                fontWeight: "900",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                color: "primary.main",
              }}
              component="span"
            >
              {title || ".........."}
            </Typography>
          </Box>
        </Tooltip>
      }
      subheader={
        <Tooltip
          title={
            folderIsExist && folder.title.length > 20
              ? folder.title
              : ""
          }
        >
          <Chip
            onClick={handleSetFolderFilter}
            label={folderIsExist ? shrotFolderTitle : "Root /"}
            icon={
              <FolderDuotone
                width="20"
                height="20"
                fill={main}
                body={cancel}
              />
            }
            sx={{
              px: "0.5em",
              fontWeight: "bolder",
              fontSize: 11,
              borderRadius: "0.5em",
              height: "2.5em",
              bgcolor: "background.card",
              boxShadow: `-5px 5px 20px -15px ${cancel} inset`,

              "& .MuiChip-label": {
                pl: "0.5em",
                py: "0.35em",
                alignSelf: "flex-end",
                color: !folderIsExist && main,
              },
            }}
          />
        </Tooltip>
      }
      component="div"
      sx={{
        height: "8em",
        px: "1.5em",
        my: "1em",
        width: "max-content",
        maxWidth: isMobile() ? "65%" : "85%",
        bgcolor: "background.cardHeader",
        borderBottomRightRadius: "5em",
        borderTopRightRadius: "5em",
        boxShadow: "5px 5px 20px -15px #000",
      }}
    />
  )
}
export default memo(Cardheader)
